import type {
  Geometry,
  GridBuildFormData,
  HorizonData,
  HorizonType,
  InterpretationData,
  MinimalCurvatureParams,
  MovingAverageParams,
} from '@core/core/types'
import type { Nullable } from 'common/types'

import { MAX_GRID_NODES, mpItems } from './constants'
import {
  isValidAnisatropyAngleParam,
  isValidBigRadiusParam,
  isValidIterationsCountParam,
  isValidMaxDescrepancyParam,
  isValidNeighborParam,
  isValidSmallRadiusParam,
} from './MapBuildingRightMenu'
import type { MapBuilderItem, MapBuilderItemType } from './types'

export const getHorizonDataItem = (id: string, color?: string, weight = 1): HorizonData => ({
  id,
  weight,
  color,
})

export const getInterpretationDataItem = (
  id: string,
  type: HorizonType,
  color?: string,
  weight = 1,
): InterpretationData => ({
  ...getHorizonDataItem(id, color, weight),
  type,
})

export const getFullNavItems = (
  additionalInfo: Partial<Record<MapBuilderItemType, string>>,
): MapBuilderItem[] => mpItems.map(item => ({ ...item, additionalText: additionalInfo[item.id] }))

export const isValidGeometry = (geometry: Geometry) =>
  ((geometry.xMax - geometry.xMin) * (geometry.yMax - geometry.yMin)) / geometry.xStep ** 2 <=
  MAX_GRID_NODES

export const isValidMethodParams = (formData: GridBuildFormData) =>
  isValidMovingAverageMethodParams(formData.movingAverage) &&
  isValidMinimalCurvatureMethodParams(formData.minimalCurvature)

const isValidMinimalCurvatureMethodParams = (params: Nullable<MinimalCurvatureParams>) =>
  isValidMaxDescrepancyParam(params) && isValidIterationsCountParam(params)

const isValidMovingAverageMethodParams = (params: Nullable<MovingAverageParams>) =>
  isValidBigRadiusParam(params) &&
  isValidSmallRadiusParam(params) &&
  isValidNeighborParam(params) &&
  isValidAnisatropyAngleParam(params)
